module.exports = __webpack_public_path__ + "img/ICONO4.9d23f46c.png";